import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ComponentPropsWithoutRef } from 'react';

const WITH_BACKGROUND_COLOR = 'withBackgroundColor';

interface FooterProps {
  [WITH_BACKGROUND_COLOR]: boolean;
}

const footerOptions = {
  shouldForwardProp: (propName: string) => propName !== WITH_BACKGROUND_COLOR,
};

export const UpperBlockStyled = styled('div', footerOptions)<FooterProps>`
  background-color: ${({ theme, withBackgroundColor }) =>
    withBackgroundColor ? theme.palette.background.default : 'none'};
  height: 62px;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    height: 75px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 40px;
  }
`;

export const FooterStyled = styled(Grid, footerOptions)<FooterProps>`
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  padding: 0 48px 40px 48px;
  background-color: ${({ theme, withBackgroundColor }) =>
    withBackgroundColor ? theme.palette.background.default : 'none'};
  color: #777;
  font-size: 12px;
  text-transform: capitalize;
  opacity: 0.5;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    flex-direction: column;
    padding: 20px 0 20px 20px;
    text-transform: none;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0 16px 32px;
  }
`;

type MainTextBlockStyledProps = ComponentPropsWithoutRef<typeof Grid> & {
  complianceFlowFooter?: boolean;
}
export const MainTextBlockStyled = styled(Grid, {
  shouldForwardProp: (propName: string) => propName !== 'complianceFlowFooter',
})<MainTextBlockStyledProps>`
  line-height: 18px;
  letter-spacing: 0.2px;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    padding-right: 80px;
    line-height: 18px;
    max-width: 100%;
  }

  ${({ theme }) => {
    return theme.breakpoints.down('sm')
  }} {
    padding-right: 0;
    line-height: 24px;
    letter-spacing: 0.1px;
  }

  ${({ theme, complianceFlowFooter }) => complianceFlowFooter && theme.breakpoints.down('sm')} {
    line-height: 16px;
  }
`;

export const BottomLinksBlockStyled = styled(Grid)`
  display: flex;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    padding-right: 4px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-right: 18px;
  }
`;

export const BottomLinksStyled = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding-left: 80px;
  line-height: 16px;
  letter-spacing: 0.3px;

  > div {
    text-transform: none;
    opacity: 0.5;
  }

  > div a:link, a:visited, a:hover, a:active {
    text-decoration: none;
    color: #777;
  }

  > div:first-of-type {
    display: block;
  }

  > div:last-of-type {
    display: none;
  }

  ${({ theme }) => theme.breakpoints.down('xl')} {
    padding-left: 0;
    line-height: 14px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    row-gap: 16px;
    flex-wrap: wrap;
    padding-right: 33vw;
    letter-spacing: 0.2px;
    line-height: 16px;

    > div:first-of-type {
      display: none;
    }

    > div:nth-of-type(3) {
      width: 28vw;
      text-align: right;
    }

    > div:nth-of-type(4) {
      width: 10vw;
    }

    > div:nth-of-type(5) {
      width: 35vw;
    }

    > div:last-of-type {
      display: block;
    }
  }
`;
